import React from "react";
import { Button } from "@mui/material";

const ReusableButton = ({
  content,
  fontSize,
  onClick,
  bgColor,
  textColor,
  hoverColor,
  hoverTextColor,
  border,
  borderRadius,
  hoverBorder,
  width,
  padding,
  disabled,
}) => {
  return (
    <Button
      sx={{
        backgroundColor: bgColor || "#000000",
        color: textColor || "#ffffff",
        fontSize: fontSize || "0.75rem",
        fontWeight: "400",
        width: width || "100%",
        margin: "0 !important",
        textTransform: "capitalize",
        borderRadius: borderRadius || "0.3rem",
        padding: padding || "0.25rem",
        border: border || "0.1rem solid #000000",
        letterSpacing: "-0.001rem",
        "&:hover": {
          backgroundColor: hoverColor || "#cccccc",
          color: hoverTextColor || "#000000",
          border: hoverBorder || "0.1rem solid #000000",
        },
      }}
      onClick={onClick}
      disabled={disabled}
      disableRipple
    >
      {content}
    </Button>
  );
};

export default ReusableButton;